import {API, getApiPath} from '@/lib/utils/api.utils';
import {isError} from '@epic-mw/error-types';
import useSWRImmutable from 'swr/immutable';
import {useIsLoggedIn} from '../account';

export type AccountOfferSubscription = {offerId: string; subscribed: boolean};

export const getAccountSubscriptionByOfferId = async (
	offerId: string
): Promise<AccountOfferSubscription> => {
	try {
		const response = await API<AccountOfferSubscription>(
			`${getApiPath()}/account/subscriptions/${offerId}`,
			{
				method: 'GET',
				withCredentials: true,
				headers: {
					'Cache-Control': 'no-store, no-cache',
					Expires: '0'
				}
			}
		);
		return response?.data;
	} catch (err) {
		console.error('subscription() failed to load', isError(err) && err.message);
		throw err;
	}
};

export const useAccountOfferSubscription = (offerId: string) => {
	const isLoggedIn = useIsLoggedIn();

	const {data, error, isLoading} = useSWRImmutable(
		isLoggedIn ? `/api/account/subscriptions/${offerId}` : null,
		() => getAccountSubscriptionByOfferId(offerId),
		{
			errorRetryCount: 1
		}
	);

	return {data, isLoading, error};
};
